export const PATH_AI_ENTRY = '/ai-chat-entry'; // ai智答入口页
export const PATH_AI_CHAT = '/ai-chat'; // AI对话
export const PATH_AI_CHAT_HISTORY = '/ai-chat-history'; // AI对话历史
